<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_PrintRange')"
    width="350px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content warehouse-dialog"
  >
    <div class="section" style="width: 100%">
      <el-form
        label-position="left"
        label-width="80px"
        style="width: 100%;"
      >
        <div style="display: flex;align-items: center;">
          <auto-number-input v-model="from.inputStart" no="inputStart" style="width: 80px;" :precision="0" :max="999" :min="1" />
          <span>-</span>
          <auto-number-input v-model="from.inputEnd" no="inputEnd" style="width: 80px;" :precision="0" :max="999" :min="1" />
          <span style="padding-left: 5px;padding-right: 5px">{{ $t('CargoMsg.Cargo_PrintNumber') }}</span>
          <auto-number-input v-model="from.printNum" no="printNum" style="width: 80px;" :precision="0" :max="999" :min="1" />
        </div>
      </el-form>
    </div>
    <div slot="footer" style="text-align: right">
      <el-button type="primary" @click="okHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveWarehouseForPalletNumberFunc } from '@/api/warehouseIn/warehouseIn'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'

export default {
  name: 'PrintDataDialog',
  components: { AutoNumberInput },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    row: {
      type: Object,
      default: null
    },
    needR: {
      type: Boolean,
      default: true
    },
    printParams: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      from: {
        inputStart: 1,
        inputEnd: 1,
        printNum: 1
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  methods: {
    inputEndData(maxNum) {
      this.from.inputEnd = maxNum || 1
    },
    onCancel() {
      this.from.inputStart = 1
      this.from.inputEnd = 1
      this.from.printNum = 1
      this.$emit('close')
    },
    okHandler() {
      if (!this.printParams || !this.printParams.WAREHOUSE_UUID ||
        this.printParams.WAREHOUSE_UUID.length === 0) {
        return
      }
      if (!this.from.printNum || !this.from.inputEnd || !this.from.inputStart || this.from.inputEnd < this.from.inputStart) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PrintCheck1'))
        return
      }
      const params = {}
      params.inputStart = this.from.inputStart
      params.inputEnd = this.from.inputEnd
      params.warehouseInKeys = this.printParams.WAREHOUSE_UUID
      saveWarehouseForPalletNumberFunc(params).then(res => {
        this.printParams.printNum = this.from.printNum
        this.$emit('printDataHandler', this.printParams)
        if (this.needR) {
          this.$emit('refresh', this.row)
        }
        this.onCancel()
      })
    }
  }
}
</script>

<style scoped>

</style>
